<div class="thank-you-wrapper">
	<div class="container">
		<div class="row">
			<div class="col-md-12">
				<div class="thank-you-text-sec">
					<img src="./assets/images/thank-you-img.png" alt="Thank You">
					<h2>Thank You</h2>
					<p>One of our executives will get in touch with you</p>
					<!--<button type="button" class="btn btn-red">Continue</button>-->
				</div>
			</div>
		</div>
	</div>
</div>
